import { lazy } from 'react'

import { authRoles } from '../../../auth/authRoles'
import { OperacionesProvider } from '../../base/contexts/OperacionesContext'
import ArticuloGestion from './view/ArticuloGestion'

const ArticuloRegistroApp = lazy(() => import('./view/ArticuloRegistro'))
const ArticuloActualizarApp = lazy(() => import('./view/ArticuloActualizar'))
const ArticuloComplementoApp = lazy(() => import('./view/ArticuloComplemento'))
const ArticuloComplementoRegistroApp = lazy(
  () => import('./view/ArticuloComplementoRegistro'),
)

export const articuloRoutesMap = {
  gestion: {
    path: '/articulo/gestion',
    name: 'Gestión de Artículos',
  },
  registro: {
    path: '/articulo/nuevo',
    name: 'Nuevo Articulo',
  },
  actualizar: {
    path: '/articulo/actualizar/:id',
    name: 'Actualizar Articulo',
  },
  complemento: {
    path: '/articulo/complemento',
    name: 'Complementos',
  },
  complementoRegistro: {
    path: '/articulo/complemento/upsert',
    name: 'Complemento Registro',
  },
}

/**
 * Estructura de ruta para cargar la página principal
 */
const articuloRoutes = [
  {
    path: articuloRoutesMap.gestion.path,
    element: (
      <OperacionesProvider>
        <ArticuloGestion />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
  {
    path: articuloRoutesMap.registro.path,
    element: (
      <OperacionesProvider>
        <ArticuloRegistroApp />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
  {
    path: articuloRoutesMap.actualizar.path,
    element: (
      <OperacionesProvider>
        <ArticuloActualizarApp />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
  {
    path: articuloRoutesMap.complemento.path,
    element: (
      <OperacionesProvider>
        <ArticuloComplementoApp />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
  {
    path: articuloRoutesMap.complementoRegistro.path,
    element: (
      <OperacionesProvider>
        <ArticuloComplementoRegistroApp />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
]

export default articuloRoutes
